<template>
    <modal class="new-modal-default"  :name="modal_name"  transition="nice-modal-fade" :delay="100"  :width="750" :height="420" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
        <div class="v-modal-content" style="background-color: #ffffff !important;">
            <div class="v-modal-header" >
                <span class="v-modal-dialog-title v-modal-title fw-600 py-3 ml-auto mr-auto" style="color: #fff !important;letter-spacing:1px;" v-if="editProductInfo">Edit Product Information</span>
                <span class="v-modal-dialog-title v-modal-title fw-600 py-3 ml-auto mr-auto" style="color: #fff !important;letter-spacing:1px;" v-else>Product Information</span>
                <button type="button" class="pointer" style="background-color: #00448b !important;outline:none;" aria-label="Close" @click="hideProductInformation()">
                    <span aria-hidden="true">
                        <i class="icon icon-close" style="color:white;margin:10px 0px 0 0;"></i>
                    </span>
                </button>
            </div>
            <div class="d-flex align-items-center justify-content-center" v-if="ajaxCallInProgress" style="height: 400px;">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else class="v-modal-body" style="overflow-x:hidden;overflow-y:scroll;">
                <!--Edit-->
                <!-- <div class="d-flex justify-content-end" v-if="editbutton && userPermissions.products.permitted_actions.edit">
                    <button type="button" class="btn btn-smm btn-new-secondary" style="border: 0 !important;border-radius: 6px !important;" @click="editProduct">
                        Edit
                    </button>
                </div> -->
                <div class="d-flex ml-1" >
                    <div v-if="editProductInfo" style="text-align:center;">
                        <hollow-dots-spinner v-if="img_loader" style="position: absolute;margin: 0;top: 22px;left:65px;display: flex;width: 108% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        <img :src="imgDataUrl || imgUrl " class="contact-image" alt="Product Pic" style="height: 6em; width: 6em; border-radius: 10px;padding:20px;border:1px solid #00448b" />
                        <upload-picture @CallLoader="CallLoader" @uploadImage="uploadImage" ></upload-picture>
                    </div>
                    <div v-else style="text-align:center;">
                        <img :src="selected_product.logo || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/SCM.svg'" class="contact-image" alt="Product Pic"
                            style="height: 6em; width: 6em; border-radius: 6px;padding:20px;border:1px solid #cdd2da;" />
                    </div>
                    <div class="w-100">
                        <div v-if="editProductInfo">
                            <div class="d-flex align-items-center justify-content-between row mx-0 mt-4 pl-5">
                                <span class="fs-14 fw-600 text-secondary"  style="top:5px !important">Product Name<sup class="pl-1 text-danger fs-14">*</sup></span>
                                <span class="float-right">
                                    <el-tooltip class="item" effect="dark" :content="starDetails" placement="top">
                                        <input class="star mr-2 mb-2 fs-20" @change="starData(is_star)" v-model="is_star" type="checkbox">
                                    </el-tooltip>
                                </span>
                            </div>
                            <div class="form-group w-100 pl-5">
                                <input class="inputFieldNew mt-0" maxlength="50" type="text" placeholder="Enter Product Name" name="product_name" v-model="product_name" v-validate="'required'" />
                            </div>
                            <div class="fs-13">
                                <span class="input-field-length float-right">{{ product_name.length }}/50</span>
                            </div>
                        </div>
                        <h6 v-else><span class="new-blue-text fw-500 ml-3 pl-2 pr-1" name="product_name">{{product_name}}</span><sup v-if="is_star" style="top: -0.6em !important;"><i class="icon icon-star" style="color: rgb(255, 154, 6); font-size: 1.5rem;"></i></sup></h6>
                        <div class="d-flex ml-5" :class="{'ml-2':editProductInfo,'mt-4':editProductInfo,'ml-5':!editProductInfo,'mt-2':!editProductInfo}">
                            <h6>
                                <span class="new-blue-text fw-500" name="product_date">Date:</span> {{created_date}}
                            </h6><br>
                            <h6 class="ml-3">
                                <span class="new-blue-text fw-500" name="product_time">Time:</span>
                                {{created_time}}
                            </h6>
                        </div>
                    </div>
                </div>
                <div v-if="editProductInfo" class="mt-4 ml-2">
                    <div>
                        <h3 class="fs-14 fw-500 text-secondary">Product Description<sup class="pl-1 text-danger fs-14">*</sup></h3>
                        <div class="inner-div">
                            <textarea-autosize maxlength="150" class="digi-textarea white-background bordered text-width mt-5"
                                name="product_description" v-model="product_description" v-validate="'required'"
                                placeholder="Enter Product Description" style="height: 6em; overflow: auto;width: 98% !important;" />
                        </div>
                    </div>
                    <div class="text-right" style="padding-right: 20px;">
                        <span class="input-field-length">{{ product_description.length }}/150</span>
                        <span class="float-left text-danger mb-3" v-show="errors.has('product_description')">Product
                            Description is required
                        </span>
                    </div>
                </div>
                <div v-else class="mt-4 ml-2">
                    <h3 class="fs-15 ml-2  pl-2 new-blue-text fw-500">Product Description</h3>
                    <div class="inner-div">
                        <textarea-autosize class="digi-textarea white-background bordered mt-3" name="product_description" v-model="product_description" style="height: 6em; overflow: auto;" :readonly="shouldDisable" />
                    </div>
                </div>
            </div>
            <div class="v-modal-footer m-auto p-4" v-if="!ajaxCallInProgress && editProductInfo && disableButtonAndDisplayLoader == false">
                <a class="btn new-cancel-button ml-2" style="height: 30px !important;" @click="hideProductInformation()">CANCEL</a>
                <a class="btn new-save-button ml-2" style="height: 30px !important;" @click="saveProduct()" v-if="fields_not_changed == false"> SAVE</a>
                <a class="btn new-save-button new-disabled ml-2" style="height: 30px !important;" v-else> SAVE</a>
            </div>
            <div v-else-if="disableButtonAndDisplayLoader == true" class="v-modal-footer m-auto p-4" style="position: relative;">
                <a class="btn btn-outline-secondary btn-smm ml-2" style="height: 30px !important;text-transform: uppercase !important;font-size: 12px !important;color: darkgray !important;border: 1px solid #E0E0E0 !important;background-color: #E0E0E0;border-radius:5px" disabled>CANCEL</a>
                <a class="btn ml-2" style="height: 30px !important;text-transform: uppercase !important;font-size: 12px !important;border-radius:5px !important;color: darkgray !important;border: 1px solid #E0E0E0 !important;background-color: #E0E0E0;" disabled> SAVE</a>
                <hollow-dots-spinner style="position: absolute;margin: 0;top: 36px;display: flex;justify-content: center;width: 148% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
            </div>
            <div class="v-modal-footer m-auto p-4" v-else-if="!ajaxCallInProgress">
                <button type="button" class="btn btn-smm btn-new-secondary" style="border: 0 !important;border-radius: 6px !important;" @click="hideProductInformation()">
                    Ok
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </modal>
</template>

<script>
    import products from '../mixins/products';
    import convert from '../mixins/convert';
    import myUpload from 'vue-image-crop-upload';
    import { SweetModal} from 'sweet-modal-vue';
    import UploadPicture from "../UploadPicture"
    import { HollowDotsSpinner } from "epic-spinners";
    import { HalfCircleSpinner } from "epic-spinners";
    export default ({
        props: ['modal_name', 'selected_product'],
        data() {
            return {
                stringified_response: "",
                disableButtonAndDisplayLoader: false,
                ajaxCallInProgress: false,
                is_star:false,
                starDetails:'',
                product_name: "",
                product_description: "",
                imgDataUrl: "",
                product_pic: '',
                imgUrl:"https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/SCM.svg",
                editProductInfo: false,
                editbutton: true,
                showProfilePic: false,
                shouldDisable: true,
                headers: {
                    smail: '*_~'
                },
                param: {
                    token: '123456798',
                    name: 'avatar'
                },
                created_date: null,
                created_time: null,
                success_msg: '',
                warning_msg: '',
                img_loader: false,
                product_data:[]
            }
        },
        mixins: [products, convert],
        methods: {
            //It's show starred and notstarred based on the conditions
            starData(data){
                if(data == true){
                    this.starDetails = "Starred"
                } else {
                    this.starDetails = "Not Starred"
                }
            },
            //Upload image data
            uploadImage (imgData) {
                this.imgDataUrl = imgData
                this.img_loader = false
            },
            //Hide View product Modal
            hideProductInformation() {
                this.$modal.hide(this.modal_name)
                this.$emit("hide-view-product-modal")
            },
            //API call to get the products
            async getProductData() {
                this.ajaxCallInProgress = true;
                let params = {
                    _id:this.selected_product,
                    edit:true
                }
                let response = await this.getScmProducts(params)
                this.product_data = response.response.result
                this.product_name = this.product_data.name
                this.product_description = this.product_data.description
                this.imgDataUrl = this.product_data.logo
                this.created_date = this.product_data.last_modified_time.split(' ')[0]
                var time = this.product_data.last_modified_time.split(' ')[1]
                var timeConverted = parseInt(time.split(':')[0]) + ':' + parseInt(time.split(':')[1]);
                this.created_time = timeConverted
                // this.is_star = response.response.is_star
                // if(this.is_star == true){
                //     this.starDetails = "Starred"
                // } else {
                //     this.starDetails = "Not Starred"
                // }
                this.ajaxCallInProgress = false;
                this.stringified_response = JSON.stringify(this.add_product)
            },
            //Api call to update products
            async updateProductData() {
                this.disableButtonAndDisplayLoader = true;
                let params = {
                    logo: this.imgDataUrl,
                    name: this.product_name,
                    description: this.product_description,
                    is_star:this.is_star,
                }
                let response = await this.updateProducts(this.selected_product.id,params)
                setTimeout(() => {
                    this.hideProductInformation();
                    this.$emit("updatedProducts")
                    this.editProductInfo = false
                    this.editbutton = true
                    this.disableButtonAndDisplayLoader = false;
                }, 1000);
            },
            editProduct() {
                this.editProductInfo = true,
                    this.shouldDisable = false,
                    this.editbutton = false,
                    this.getProductData();
            },
            saveProduct() {
                this.$validator.validateAll().then(async result => {
                    this.updateProductData();
                });
            },
            CallLoader(){
                this.img_loader = true
            }
        },
        mounted() {
            this.getProductData();
        },
        components: {
            myUpload,
            SweetModal,
            UploadPicture,
            HollowDotsSpinner,
            HalfCircleSpinner,
        },
        computed:{
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            add_product() {
                return {
                    logo: this.imgDataUrl,
                    name: this.product_name,
                    description: this.product_description,
                    is_star:this.is_star
                }
            },
            fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.add_product)
            }
        }
    })
</script>

<style scoped>
    .btn-backcolor:hover {
        background-color: #fff !important;
    }
    .star {
        visibility:hidden;
        font-size:30px;
        cursor:pointer;
    }
    .star:checked:before {
        content: "\2605";
        position: absolute;
        color: rgb(255, 154, 6);
        visibility:visible;
    }
    .star:before {
        content: "\2606";
        position: absolute;
        visibility:visible;
        color: #000;
    }
    .new-disabled{
        cursor: not-allowed !important;
        background-color: #ABABAB !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/products/ProductView.vue